import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { AuthTextInputProps } from "../../../interface/types";
import { InputAdornment } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const AuthTextInput: React.FC<AuthTextInputProps> = ({
  label,
  placeholder,
  icon,
  autoFocus,
  onChange,
  name,
  value,
  types,
  page,
  customStyle = {},
  module,
  required,
  disable
}) => {
  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const { backgroundColor, border, flexDirection }: any = customStyle;
  const isRow = flexDirection === "row";
  const isInvoice = module === "invoice";
  const handlePassword = () => {
    setPasswordShow(!passwordShow);
  };

  const handleChange = (e:any) => {
    if (onChange) {
      onChange(module === "invoice" ? e.target.value : e); // Call the prop with just the value
    }
  };

  return (
    <div
      className={`!mt-[2rem] w-full flex items-center ${
        isRow ? "flex-row gap-4 justify-start" : `flex-${flexDirection || "col"} justify-center`
      } ${flexDirection && !isRow ? "gap-4" : ""}`}
    >
      <label
        className={`text-textGray text-[0.8rem] flex gap-2 shrink-0 ${
          isRow || isInvoice
            ? "min-w-[8.5rem] w-[8.5rem] !mb-0"
            : "!mb-[0.5rem]"
        } ${
          page === "settings" ? "self-start text-left" : ""
        } ${flexDirection && !isRow && !isInvoice ? "min-w-[6rem]" : ""}`}
      >
        {label}
        {module === "invoice" && required && <span className="text-red-500">*</span>}
      </label>

      <div className={isRow ? "flex-1 min-w-0" : "w-full"}>
      <TextField
        placeholder={placeholder}
        type={types === "password" && passwordShow ? "text" : types}
        autoFocus={autoFocus}
        fullWidth
        value={value}
        name={name}
        disabled={disable}
        onChange={handleChange}
        variant="outlined"
        className="w-full"
        sx={{
          "& .MuiOutlinedInput-root": {
            height: "2.3rem",
            paddingRight: "0.5rem",
            backgroundColor: backgroundColor ?? "#EEEEEE",
            "& fieldset": {
              border: border ?? "none",
            },
          },
          "& input": {
            fontSize: "0.8rem",
            padding: "0.5rem 0.5rem",
          },
        }}
        inputProps={
          types === "password" ? { maxLength: 15 } : { maxLength: 250 }
        }
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {types === "password" ? (
                <div
                  onClick={handlePassword}
                  className="cursor-pointer !w-[1.2rem]  !mr-[0.5rem]"
                >
                  {passwordShow ? (
                    <VisibilityOutlinedIcon
                      fontSize="small"
                      sx={{ opacity: 0.6 }}
                    />
                  ) : (
                    <VisibilityOffOutlinedIcon
                      fontSize="small"
                      sx={{ opacity: 0.6 }}
                    />
                  )}
                </div>
              ) : icon ? (
                <img
                  src={icon}
                  alt="icon"
                  className="w-[1.2rem]  opacity-60 !mr-[0.5rem]"
                />
              ) : null}
            </InputAdornment>
          ),
        }}
      />
      </div>
    </div>
  );
};

export default AuthTextInput;
